import processApiResponse from "lib/process-api-response"
import sendConventionApiRequest from "lib/send-convention-api-request"
import { Current } from "lib/use-current"

interface PostConventionMeetingRegistrationParameters {
  current: Current
  id: string
  attributes: {
    convention_meeting_availability_id: string
    start_at: string
    end_at: string
  }
}

interface PostConventionMeetingRegistrationResponse {
  end_at: string
  id: string
  meeting_availability_id: string
  start_at: string
  _type: "meeting_registration"
}

export default async function postConventionMeetingRegistration(
  parameters: PostConventionMeetingRegistrationParameters,
) {
  const { current, id, attributes } = parameters

  const providerId = current.provider?.id
  if (!providerId) throw "providerId is not defined"

  const response = await sendConventionApiRequest({
    current,
    method: "POST",
    url: `v1/convention_providers/${providerId}/convention_meeting_registrations`,
    body: {
      data: {
        id,
        type: "meeting_registration",
        attributes,
      },
    },
  })

  return await processApiResponse<PostConventionMeetingRegistrationResponse>(response)
}
